import * as Sentry from '@sentry/react';
import { redactPii } from '@this+that/utils/redactPii';

export function initSentry(dsn: string, enabled = true) {
  Sentry.init({
    enabled,
    dsn,
    environment: 'production',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.thisandthat\.chat/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // The loglevel wrap already cleans console breadcrumbs; these two cover what never
    // reaches the console — captureException payloads and fetch/dom breadcrumbs.
    beforeSend: (event) => redactPii(event) as typeof event,
    beforeBreadcrumb: (breadcrumb) =>
      redactPii(breadcrumb) as typeof breadcrumb,
  });

  if (!enabled) {
    return;
  }

  // Replay is heavy + non-critical; load it from Sentry's CDN so it stays out of
  // the main bundle. rolldown can't code-split the npm import (init needs
  // @sentry/react statically), so lazyLoadIntegration is the only real defer.
  Sentry.lazyLoadIntegration('replayIntegration')
    .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
    .catch(() => {
      /* Session Replay is optional; ignore if the CDN load fails. */
    });
}
